module.exports = __webpack_public_path__ + "static/lady-sitting-317fe9fac66c568d128fa09298ea2f66.png";